import { PickerPlan } from '../../../lib/plans';

export const SETTINGS_PAGE = { page_name: 'settings_page' as const, origin: 'dashboard' as const };

export type ExternalLinkAction = 'privacy_policy' | 'terms_of_service' | 'open_source_license';

export const EXTERNAL_LINKS: { labelKey: string; href: string; biAction: ExternalLinkAction }[] = [
  { labelKey: 'settings.help.privacy', href: 'https://www.wix.com/about/privacy', biAction: 'privacy_policy' },
  { labelKey: 'settings.help.terms', href: 'https://www.wix.com/about/terms-of-use', biAction: 'terms_of_service' },
  { labelKey: 'settings.help.licenses', href: 'https://oneapp1.wixsite.com/licenses', biAction: 'open_source_license' },
];

// "Contact us" — one destination for both surfaces (opens the support portal).
export const SUPPORT_URL = 'https://support.wix.com';

export const INK = (a: number) => `rgba(var(--ink-rgb),${a})`;

export interface ScheduledChangeResp {
  hasPendingChange: boolean;
  pendingPlanId: string | null;
  scheduledChangeDate: string | null;
  pendingCancellation: boolean;
  cancellationDate: string | null;
}

export function resetLabel(iso: string | null): string | null {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  if (Number.isNaN(ms) || ms <= 0) return null;
  const hours = Math.round(ms / 3_600_000);
  if (hours >= 48) return `Resets in ${Math.round(hours / 24)} days`;
  if (hours >= 1) return `Resets in ${hours}h`;
  return 'Resets soon';
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * The catalog KEY for a plan's tier name (e.g. `pricing.plan.max.name`), or null when the plan
 * isn't in the loaded catalog. A key rather than a name because the catalog carries no language —
 * see lib/plans.ts — so every caller resolves it with `t()` in the reader's locale.
 */
export function planNameKeyOf(plans: PickerPlan[] | null, planId: string | null | undefined): string | null {
  if (!plans || !planId) return null;
  for (const p of plans) {
    if (p.options.some((o) => o.agentPlanId === planId)) return p.nameKey;
  }
  return null;
}
